import { formatShortDate, money } from "../format"

type Props = {
    label?: string
    amountPence?: number
    deliveryPence?: number | null
    showDelivery?: boolean
    hireLabel?: string | null
    dates?: { deliveryDate: string; collectionDate: string }
    loading?: boolean
}

export function MobileBookingTotals({ label = "Total Amount Due", amountPence, deliveryPence = null, showDelivery = true, hireLabel, dates, loading = false }: Props) {
    const showAmount = amountPence !== undefined
    const showMeta = Boolean(showDelivery || dates || hireLabel)
    if (!showAmount && !showMeta) return null
    return <div className="ah-selection-totals">
        {showAmount && <div className="ah-mobile-total"><small>{label}</small>{loading ? <div className="ah-skeleton ah-skeleton-price" aria-hidden="true" /> : <strong>{money(amountPence)}</strong>}</div>}
        {showMeta && <div className="ah-selection-meta">
            {showDelivery && <span className="ah-mobile-delivery"><span aria-hidden="true">🚚</span><span className="ah-delivery-label">{deliveryPence === null ? "Delivery: —" : deliveryPence === 0 ? "Free delivery & collection" : `Delivery & collection: ${money(deliveryPence)}`}</span></span>}
            {dates ? <span className="ah-mobile-hire-dates"><span>{formatShortDate(dates.deliveryDate)}</span>{" to "}<span>{formatShortDate(dates.collectionDate)}</span></span> : hireLabel && <span className="ah-mobile-hire-duration">{hireLabel}</span>}
        </div>}
    </div>
}
